import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

type SampleJobArchiveDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  sampleName: string
  isPending: boolean
  onConfirm: () => void
}

export function SampleJobArchiveDialog({
  open,
  onOpenChange,
  sampleName,
  isPending,
  onConfirm,
}: SampleJobArchiveDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete sample job</AlertDialogTitle>
          <AlertDialogDescription>
            Remove {sampleName} from the Simulation list? People, organisations, and the draft
            job stay in the tenant until you remove them with the controls on this bench.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isPending}
            className="bg-destructive text-destructive-foreground"
          >
            {isPending ? 'Deleting…' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
